export enum EActions {
  CARD_LIST_REQUEST = 'CARD_LIST_REQUEST',
  CARD_LIST_REQUEST_SUCCESS = 'CARD_LIST_REQUEST_SUCCESS',
  CARD_LIST_REQUEST_ERROR = 'CARD_LIST_REQUEST_ERROR',
  ADD_TO_FAVORITES = 'ADD_TO_FAVORITES',
  REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES',

  SET_SEARCH_VALUE = 'SET_SEARCH_VALUE',
  RESET_SEARCH_VALUE = 'RESET_SEARCH_VALUE',

  SORT_BY_AGE = 'SORT_BY_AGE',
  SORT_BY_ID = 'SORT_BY_ID',
  SORT_BY_NAME = 'SORT_BY_NAME',
  SORT_BY_DECREASE = 'SORT_BY_DECREASE',
  SORT_BY_INCREASE = 'SORT_BY_INCREASE',

  SET_TABLE_VIEW = 'SET_TABLE_VIEW',
  SET_CARDS_VIEW = 'SET_CARDS_VIEW',
}
